module.exports = __webpack_public_path__ + "img/logo-icon.6bb67617.png";